<template>
  <div id="app">
    <nav>
      <div class="menuu">
        <logo-view style="margin-right: 500px;"/>
        <el-menu :default-active="rootActiveMenu" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/introduction">产品</el-menu-item>
          <el-menu-item index="/communication">联系我们</el-menu-item>
        </el-menu>
      </div>
    </nav>
    <router-view/>
  </div>
</template>

<style lang="scss">
.menuu {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .el-menu--horizontal>.el-menu-item {
    height: 80px;
    line-height: 80px;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>

<script>
  import LogoView from '@/components/LogoView'
  export default {
    components: {LogoView},
    data() {
      return {
        activeIndex: '1',
      };
    },
    methods: {
      handleSelect(index) {
        this.$router.push(index)
      }
    },
    computed: {
      rootActiveMenu () { // 头部根菜单高亮和显示哪个模块的的菜单， 菜单的 serviceCode ===meta.rootActiveMenu 还有针对ROUTER_403、ROUTER_EMPTY使用active
        const route = this.$route
        const { meta, path } = route
        if (meta.rootActiveMenu) { // 注意这里很重要
          return meta.rootActiveMenu
        }
        return path
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue